import { text_mod_57 } from "../text/Text.js";

export const module57 = {
  title: "Правопис і наголошування числівників",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_57,
    },
  ],
};
